export interface Permission {
  featureId: number;
  featureName: string;
  category: string;
  allowRead: boolean;
  allowWrite: boolean;
  allowDelete: boolean;
  allowCentralAccess: boolean;
  allowExcelExport: boolean;
  supportsRead?: boolean;
  supportsWrite?: boolean;
  supportsDelete?: boolean;
  supportsCentralAccess?: boolean;
  supportsExcelExport?: boolean;
  isActive?: boolean;
  isRemovedFromErp?: boolean;
}

export interface UserPermissions {
  userId: string;
  permissions: Permission[];
  roleTemplate: Permission[] | null;
  deviations: PermissionDeviation[];
}

export interface PermissionDeviation {
  featureId: number;
  featureName: string;
  category: string;
  field: PermissionField;
  direction: 'above' | 'below';
}

export type PermissionField = 'allowRead' | 'allowWrite' | 'allowDelete' | 'allowCentralAccess' | 'allowExcelExport';

export const PERMISSION_FIELDS: PermissionField[] = ['allowRead', 'allowWrite', 'allowDelete', 'allowCentralAccess', 'allowExcelExport'];

export const PERMISSION_FIELD_LABELS: Record<PermissionField, string> = {
  allowRead: 'Read',
  allowWrite: 'Write',
  allowDelete: 'Delete',
  allowCentralAccess: 'Central Access',
  allowExcelExport: 'Export'
};
